const VideoComponentConfig = (editor) => {
	// Get the existing video component type
	const defaultType = editor.DomComponents.getType('video');
	const defaultModel = defaultType.model;

	// Extend the built-in video component to add referrerpolicy attribute
	editor.DomComponents.addType('video', {
		model: defaultModel.extend({
			defaults: {
				...defaultModel.prototype.defaults,
				// Override attributes to add referrerpolicy
				attributes: {
					...defaultModel.prototype.defaults.attributes,
					referrerpolicy: 'strict-origin-when-cross-origin',
					allowfullscreen: 'allowfullscreen',
				},
			},
		}),
		view: defaultType.view,
	});
};

export default VideoComponentConfig;
